import styled from 'styled-components';
import { media } from 'legacyComponents/styled/styleUtils';

export const TagsMainWrapper = styled.div`
  float: ${props =>
    props.centered ? 'none' : props.float ? props.float : 'left'};
  ${media.s`
    display: ${props => (props.canBeHidden ? 'none' : 'block')};
  `}
`;

export const TagsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
